export { BarChartAlt as default } from './BarChartAlt';
